<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'" class="component-wrapper">
    <app-sokusai-login class="component"></app-sokusai-login>
  </div>

  <div *ngIf="page === 'register'" class="component-wrapper">
    <app-sokusai-register class="component"></app-sokusai-register>
  </div>

  <div *ngIf="page === 'forgot-password'" class="component-wrapper">
    <app-sokusai-forgot-password class="component"></app-sokusai-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'" class="component-wrapper">
    <app-sokusai-change-password-sent class="component"></app-sokusai-change-password-sent>
  </div>

  <div class="component-wrapper">
    <app-sokusai-register-resend
      *ngIf="page === 'register-resend'"
    ></app-sokusai-register-resend>
  </div>
</ng-container>
